import { render, staticRenderFns } from "./UredajObavijest.vue?vue&type=template&id=a43999b6&scoped=true&"
import script from "./UredajObavijest.vue?vue&type=script&lang=js&"
export * from "./UredajObavijest.vue?vue&type=script&lang=js&"
import style0 from "./UredajObavijest.vue?vue&type=style&index=0&id=a43999b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43999b6",
  null
  
)

export default component.exports